/* eslint-disable @typescript-eslint/no-unnecessary-condition -- Wrong typing, ownerState cen be null */
import { alertClasses } from '@mui/material';
import { alpha } from '@mui/system';
import { CheckCircle, ErrorCircle, InfoCircle, Warning } from '@ori-ui/icons';
import { colors } from '../constants';
import { jsx as _jsx } from "react/jsx-runtime";
const styleOverrides = {
  root: ({
    theme,
    ownerState
  }) => ({
    padding: '10px 15px ',
    [theme.breakpoints.up('sm')]: {
      padding: '10px 30px '
    },
    ...(ownerState?.color === 'default' && ownerState?.variant === 'filled' && {
      backgroundColor: alpha(colors.commonColors.black, 0.6),
      color: colors.commonColors.white
    }),
    ...(ownerState?.color === 'default' && ownerState?.variant === 'standard' && {
      backgroundColor: alpha(colors.defaultColors.light, 0.1),
      color: colors.defaultColors.main,
      borderColor: colors.defaultColors.main
    }),
    ...((ownerState?.severity === 'success' || ownerState?.color === 'success') && ownerState?.variant === 'filled' && {
      color: colors.commonColors.white
    }),
    ...((ownerState?.severity === 'warning' || ownerState?.color === 'warning') && (ownerState?.variant === 'standard' || ownerState?.variant === 'outlined') && {
      [`& .${alertClasses.icon}`]: {
        color: colors.text.primary
      }
    })
  }),
  standardInfo: ({
    ownerState
  }) => ({
    backgroundColor: alpha(colors.info.main, 0.1),
    color: colors.info.dark,
    borderColor: colors.info.main
  }),
  standardError: {
    backgroundColor: alpha(colors.error.main, 0.1),
    color: colors.error.dark,
    borderColor: colors.error.dark
  },
  standardSuccess: {
    backgroundColor: alpha(colors.success.main, 0.1),
    color: colors.success.dark,
    borderColor: colors.success.dark
  },
  standardWarning: {
    backgroundColor: alpha(colors.warning.dark, 0.14),
    color: colors.text.primary,
    borderColor: colors.warning.dark
  },
  outlinedWarning: {
    color: colors.text.primary,
    borderColor: colors.warning.dark
  },
  message: ({
    theme
  }) => ({
    dispaly: 'grid',
    alignContent: 'center',
    textWrap: 'balance',
    fontSize: theme.typography.body1.fontSize,
    padding: '10px 0'
  }),
  icon: ({
    theme
  }) => ({
    fontSize: '2.4rem',
    lineHeight: 1,
    opacity: '1',
    padding: '7.5px 0',
    marginRight: '10px'
  })
};
const defaultProps = {
  severity: 'info',
  iconMapping: {
    error: /*#__PURE__*/_jsx(ErrorCircle, {
      fontSize: "inherit"
    }),
    info: /*#__PURE__*/_jsx(InfoCircle, {
      fontSize: "inherit"
    }),
    success: /*#__PURE__*/_jsx(CheckCircle, {
      fontSize: "inherit"
    }),
    warning: /*#__PURE__*/_jsx(Warning, {
      fontSize: "inherit"
    })
  }
};
export default {
  defaultProps,
  styleOverrides
};
//# sourceMappingURL=MuiAlert.js.map